function isKeyOfObject(key, obj) {
  return !!key && key in obj;
}
export {
  isKeyOfObject
};
